import useForm from 'tennders-common/form/hooks/useForm'
import { useEffect, useState } from 'react'
import PubSub from 'pubsub-js'

const defaultLineForm = {
  concept: '',
  amount: 0,
  vatPercentage: 0,
  totalAmount: 0,
  totalVatAmount: 0,
  transactionId: null,
  type: 'specific-transaction',
  orderNo: 'all'

}

const useMultipleSalesInvoiceExtraCostRow = ({ initialErrors, index }) => {
  const { form, errors, setform: setForm } = useForm({ initialForm: defaultLineForm, initialErrors })

  const [transaction, setTransaction] = useState(null)
  const onTransactionChange = (transaction) => {
    if (transaction) {
      setTransaction(transaction)
      setForm({
        ...form,
        transactionId: transaction.id,
        orderNo: transaction.referenceNumber
      })
    } else {
      setTransaction(null)
      setForm({ ...form, transactionId: null, orderNo: null })
    }
  }
  const processForm = (key, value, form) => {
    const newForm = { ...form, [key]: value }

    if (key === 'vatPercentage' || key === 'amount') {
      const percentage = newForm.vatPercentage ? (parseFloat(newForm.vatPercentage) / 100) : 0
      const amount = parseFloat(newForm.amount)
      const vatAmount = amount * percentage
      newForm.totalAmount = amount + vatAmount
      newForm.vatAmount = vatAmount
    }

    return newForm
  }

  const onChange = (key, value) => {
    setForm(prev => processForm(key, value, prev))
  }

  useEffect(() => {
    const unsubscribe = PubSub.subscribe(`multiple-sales-invoice-extra-cost:${index}:change`, (msg, data) => {
      setForm(prevState => ({ ...prevState, ...data }))
    })
    return () => PubSub.unsubscribe(unsubscribe)
  }, [index])

  return { form, errors, setForm, onChange, transaction, onTransactionChange }
}

export default useMultipleSalesInvoiceExtraCostRow
